import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'

import { sortNumericColumn, sortStringColumn } from '../../../../components/tables/utils'
import { RatingComplianceRule } from './models'

const renderActionsMenu =
  ({
    onUpdate,
    onDelete,
  }: {
    onUpdate: (rule: RatingComplianceRule) => void
    onDelete: (rule: RatingComplianceRule) => void
  }) =>
  (_: any, rule: RatingComplianceRule) => {
    const menu = (
      <Menu>
        <Menu.Item key="updateTrade" onClick={() => onUpdate(rule)}>
          Update Rating Compliance Rule
        </Menu.Item>
        <Menu.Item key="deleteRule" onClick={() => onDelete(rule)}>
          Delete Rating Compliance Rule
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const buildRatingComplianceRulesTableColumns = ({
  onUpdate,
  onDelete,
}: {
  onUpdate: (rule: RatingComplianceRule) => void
  onDelete: (rule: RatingComplianceRule) => void
}) => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: sortNumericColumn({ dataIndex: 'id' }),
  },
  {
    title: 'Rating Type',
    dataIndex: 'ratingType',
    sorter: sortStringColumn({ dataIndex: 'ratingType' }),
  },
  {
    title: 'Rating',
    dataIndex: 'rating',
    sorter: sortStringColumn({ dataIndex: 'rating' }),
  },
  {
    title: 'Max Limit',
    dataIndex: 'maxLimit',
    sorter: sortNumericColumn({ dataIndex: 'maxLimit' }),
  },
  { title: '', render: renderActionsMenu({ onUpdate, onDelete }) },
]
